import styled from 'styled-components';
export const BadgeWrapper = styled.span `
  display: inline-flex;
  column-gap: var(--spacing-1);
  align-items: center;
  font-size: var(--font-size-xxxs);
  padding: var(--spacing-0-5) var(--spacing-1);
  border-radius: var(--border-radius-xs);
  font-family: var(--font-family);
  background: var(--color-neutral-80);
  color: var(--color-neutral-130);
  font-weight: 600;

  &.success {
    background: var(--color-feedback-success-80);
    color: var(--color-feedback-success-120);
  }

  &.info {
    background: var(--color-feedback-info-80);
    color: var(--color-feedback-info-110);
  }

  &.warning {
    background: var(--color-feedback-attention-80);
    color: var(--color-feedback-attention-110);
  }

  &.secondary {
    background: var(--color-secondary-70);
    color: var(--color-secondary-100);
  }

  &.error {
    background: var(--color-feedback-error-80);
    color: var(--color-feedback-error-110);
  }

  svg {
    max-width: 16px;
    max-height: 16px;
  }
`;
